<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="6"          
        md="12"
        sm="12"
        xl="4"
      >
        <setup-discipline-type-of-misconduct-dialog-create
          v-if="$hasPermissionTo(['create type of misconducts'])"
          :version-starter="versionStarter"
          :job-group-policies="jobGroupPolicies"
          :type-of-misconduct-revisions="typeOfMisconductRevisions"
          @created="loadData"
        />
        <setup-discipline-type-of-misconduct-dialog-copy
          v-if="$hasPermissionTo(['create type of misconducts'])"
          :version-starter="versionStarter"
          :job-group-policies="jobGroupPolicies"
          :type-of-misconduct-revisions="typeOfMisconductRevisions"
          @created="loadData"
        />
        <setup-discipline-type-of-misconduct-dialog-bulk-edit
          v-if="$hasPermissionTo(['update type of misconducts'])"
          :job-group-policies="jobGroupPolicies"
          :type-of-misconduct-revisions="typeOfMisconductRevisions"
          @updated="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="2"          
        md="12"
        sm="12"
        xl="1"
      >
        <v-autocomplete
          v-model="version"
          :items="typeOfMisconductRevisions"
          label="Version"
          item-text="name"
          item-value="id"
          @change="loadData"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="2"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-autocomplete
          v-model="group"
          :items="jobGroupPoliciesWithNull"
          item-text="name"
          item-value="id"
          label="Job Group Policy"
          clearable
          @change="loadData"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="2"          
        md="12"
        sm="12"
        xl="1"
      >
        <v-autocomplete
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in type of misconducts here"
          append-icon="search"
          label="Search Type of Misconduct"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredTypeOfMisconducts"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <span v-html="item.name" />
      </template>

      <template v-slot:item.group="{ item }">
        {{ item.job_group_policy ? item.job_group_policy.name : 'N/A' }}
      </template>
    
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-discipline-type-of-misconduct-dialog-edit
            v-if="$hasPermissionTo(['update type of misconducts'])"
            :type-of-misconduct="item"
            :job-group-policies="jobGroupPolicies"
            :type-of-misconduct-revisions="typeOfMisconductRevisions"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-discipline-type-of-misconduct-dialog-delete
            v-if="$hasPermissionTo(['delete type of misconducts'])"
            :type-of-misconduct="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-discipline-type-of-misconduct-dialog-restore
            v-if="$hasPermissionTo(['restore type of misconducts'])"
            :type-of-misconduct="item"
            @restored="loadData"
          />
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupDisciplineTypeOfMisconductDialogCreate: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogCreate'),
      SetupDisciplineTypeOfMisconductDialogCopy: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogCopy'),
      SetupDisciplineTypeOfMisconductDialogDelete: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogDelete'),
      SetupDisciplineTypeOfMisconductDialogRestore: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogRestore'),
      SetupDisciplineTypeOfMisconductDialogEdit: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogEdit'),
      SetupDisciplineTypeOfMisconductDialogBulkEdit: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogBulkEdit'),
    },
    data () {
      return {
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
            width: '100',
            sortable: false,
          },
          {
            text: 'Type of Misconducts',
            align: 'left',
            value: 'name',
            sortable: false,
          },
          {
            text: 'Job Group Policy',
            align: 'left',
            value: 'group',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
            width: '120',
          },
        ],
        search: '',
        versionStarter: '',
        tableLoading: true,
        typeOfMisconducts: [],
        trashedTypeOfMisconducts: [],
        typeOfMisconductRevisions: [],
        jobGroupPolicies: [],
        version: null,
        group: null,
      }
    },
    computed: {
      filteredTypeOfMisconducts () {
        return this.statusFilter ? this.typeOfMisconducts : this.trashedTypeOfMisconducts
      },
      jobGroupPoliciesWithNull () {
        let temp = [ ...this.jobGroupPolicies ]

        temp.push({ id: 'null', name: 'N/A' })

        return temp
      },
    },
    mounted () {
      this.loadSystemSettings()
      this.loadData()
    },
    methods: {
      loadJobGroupPolicies () {
        this.$api.jobGroupPolicies().list()
          .then(res => {
            this.jobGroupPolicies = _.orderBy(res.data, ['name'], ['asc'])
          })
      },
      loadTypeOfMisconductRevisions () {
        this.$api.typeOfMisconductRevisions().list()
          .then(res => {
            let temp = _.orderBy(res.data, ['id'], ['desc'])
            this.typeOfMisconductRevisions = temp.map(revision => {
              return {
                ...revision,
                name: this.versionStarter + revision.version,
              }
            })

            if (this.typeOfMisconductRevisions.length > 0) {
              this.version = this.version ? this.version : this.typeOfMisconductRevisions.find(revision => { 
                return revision.start_date <= this.$moment().format('YYYY-MM-DD') && (!revision.end_date || (revision.end_date >= this.$moment().format('YYYY-MM-DD')))
              }).id
            }
          })
      },
      loadSystemSettings () {
        this.$api.systemSettings().list()
          .then((res) => {
            this.versionStarter = res.data.find(setting => setting.key === 'VERSION_STARTER').value
          })
          .catch(() => {})
      },
      loadData () {
        this.loadJobGroupPolicies()
        this.loadTypeOfMisconductRevisions()
        
        Promise.all([
          this.$api.typeOfMisconducts().list({ version_id: this.version, group_id: this.group }),
          this.$api.typeOfMisconducts().listTrashed({ version_id: this.version, group_id: this.group }),
        ]).then(([typeOfMisconduct, trashedTypeOfMisconduct]) => {
          this.typeOfMisconducts = typeOfMisconduct.data
          this.trashedTypeOfMisconducts = trashedTypeOfMisconduct.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
